import React, { useState, useEffect } from "react";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import Endpoints from "../../api/endpoints";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Table } from "antd";
import { ApplicationColumns } from "./ApplicationColumns";
import routes from "../../utils/routes";
import { useNavigate } from "react-router-dom";
const Applications = () => {
  const axiosPrivate = useAxiosPrivate();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApplications = async () => {
      setLoading(true);
      try {
        const response = await EndpointFunctions.fetchData({
          axiosPrivate: axiosPrivate,
          endpointURL: Endpoints.getAllApplications,
        });
        setApplications(response.data);
        setLoading(false);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchApplications();
  }, []);

  const goToUpdatePage = ({ record }) => {
    console.log("record", record);

    const id = record.id;
    let path = `${routes.updateApplication}/${id}`;
    navigate(path);
  };

  console.log("applications", applications);
  return (
    <>
      <div style={{ height: 20 }} />
      <Table
        pagination={false}
        dataSource={applications}
        columns={ApplicationColumns({ goToUpdatePage })}
        scroll={{ x: true }}
        loading={loading}
      />
    </>
  );
};

export default Applications;
